import React, { useCallback, useState } from "react";
import Request from "../../../core/requests";
import { ValidationSchemaReset } from "../../../conf/login";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ForgotPasswordForm from "forms/authentication/ForgotPassword.form";
import { useDispatch } from "react-redux";
import { openSnackbar } from "store/slices/snackbar";
import CardFormComponent from "components/common/card/CardForm.component";
import WrapperSliderCard from "components/common/card/WrapperSliderCard.component";
import { useTranslation } from "react-i18next";

const ForgotPasswordContainer = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isSubmitting, setSubmitting] = useState(null);

    const { handleSubmit, control, formState } = useForm({
        resolver: yupResolver(ValidationSchemaReset),
        defaultValues: {
            email: "",
        },
    });

    const onSuccess = useCallback(() => {
        setSubmitting(true);
        dispatch(
            openSnackbar({
                open: true,
                message: "Verifica la tua email per il link di reset password",
                variant: "alert",
                alert: {
                    color: "success",
                },
                close: false,
            })
        );
        setTimeout(() => {
            navigate("/login", { replace: true });
        }, 2000);
        // eslint-disable-next-line
    }, []);

    const onFailure = useCallback((error) => {
        dispatch(
            openSnackbar({
                open: true,
                message: error.message ? error.message : "",
                variant: "alert",
                alert: {
                    color: "error",
                },
                close: false,
            })
        );
        // eslint-disable-next-line
    }, []);

    const onSubmit = useCallback((data) => {
        Request.users
            .reset(data)
            .then((resp) => onSuccess(resp.message))
            .catch((error) => onFailure(error));
        // eslint-disable-next-line
    }, []);

    return (
        <WrapperSliderCard>
            <CardFormComponent
                title={t("Forgot password?")}
                subTitle={t('Enter your email address to receive the reset link')}
                subButton={{ label: t('Do you already have an account?'), href: "/login" }}
            >
                <ForgotPasswordForm
                    errors={formState.errors}
                    control={control}
                    isSubmitting={isSubmitting}
                    handleSubmit={handleSubmit(onSubmit)}
                />
            </CardFormComponent>
        </WrapperSliderCard>
    );
};

export default ForgotPasswordContainer;
